import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import IconButton from '../IconButton';
import { DSIcon } from '../../../base';

import Button from '../Button';

import styles from './BackButtonDesktop.module.scss';

const BackButtonDesktop = ({
  className = '',
  textKey = 'listing.back',
  underline = false,
  ...props
}) => {
  const classes = classNames(styles['back-button-desktop'], className);
  const textClasses = classNames(styles['back-button-desktop__text'], {
    [styles['back-button-desktop__text--underline']]: underline
  });
  return (
    <Button
      className={classes}
      contentClassName={styles['back-button-desktop__content']}
      {...props}
    >
      <DSIcon
        name="arrow_left"
        className={styles['back-button-desktop__icon']}
      />
      <span className={textClasses}>{trans(textKey)}</span>
    </Button>
  );
};

BackButtonDesktop.propTypes = {
  ...IconButton.propTypes,
  textKey: PropTypes.string
};

export default BackButtonDesktop;
